<template>
  <div class="color-selector">

    <div class="row1">
       <div class="pallate pallate-foreground"
         @click="setSelected()"
         v-bind:style="{ background: activeColor.color.hex(), color: reverseColor.color.hex() }"
         v-bind:class="{ active: hasGlobalFocus() }">
      <div class="pallate-name">
        {{ label }}

      </div>
      <div class="active"
           v-show="hasGlobalFocus()"
           v-bind:style="{ background: reverseColor.color.hex() }" />
     </div>
     <div class="row1-right">
        <flip-icon/>
        <div style="flex: 1"></div>
        <div class="boxes">
          <div class="box"></div>
          <div class="box"></div>
          <div class="box"></div>
          <div class="box"></div>
        </div>
     </div>

    </div>
   

    <div class="color-inputs hide-on-mobile">

      <div class="eyedropper basic-button"
           @click="sampleColor">
        <svg width="15"
             height="19"
             viewBox="0 0 15 19"
             fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <g opacity="0.6"
             clip-path="url(#clip0)">
            <path d="M13.6322 1.43558L12.6453 0.422251C12.0901 -0.147749 11.206 -0.147749 10.6714 0.422251L9.47879 1.6467L8.80026 0.950029C8.63577 0.78114 8.38903 0.78114 8.22454 0.950029L6.90861 2.30114C6.74412 2.47003 6.74412 2.72336 6.90861 2.89225L7.62826 3.61003L1.66544 9.73225C1.58319 9.81669 1.52151 9.98558 1.52151 10.0911L1.50094 11.6534L0.637363 12.54C0.308379 12.8778 0.308379 13.4267 0.637363 13.7645C0.801854 13.9334 1.02803 14.0178 1.23364 14.0178C1.45982 14.0178 1.66544 13.9334 1.82993 13.7645L2.69351 12.8778L4.21506 12.8567C4.33843 12.8567 4.48236 12.7934 4.5646 12.7089L10.5274 6.5867L11.2265 7.30447C11.391 7.47336 11.6583 7.47336 11.8022 7.30447L13.1182 5.95336C13.2827 5.78447 13.2827 5.53114 13.1182 5.36225L12.4396 4.66558L13.6322 3.44114C14.1874 2.91336 14.1874 2.00558 13.6322 1.43558ZM8.36847 7.62114H4.87302L8.03949 4.37003L9.78721 6.16447L8.36847 7.62114Z"
                  fill="black" />
            <path d="M1.23271 15.0945C0.677553 16.4456 0.0607089 16.9311 -0.000975525 17.7756C-0.0420985 18.3878 0.348569 19 1.23271 19C2.11686 19 2.50752 18.3878 2.4664 17.7756C2.40472 16.9311 1.78787 16.4456 1.23271 15.0945Z"
                  fill="black" />
          </g>
        </svg>

      </div>

      <div class="color-input-row"
           v-if="showColorMode('rgb')">
        <color-input mode="hex"
                     :target="target" />
        <div style="flex: 1"></div>
        <!-- <color-input mode="rgb"
                     :target="target" /> -->
      </div>

      <div class="color-input-row"
           v-if="showColorMode('hsl')">
        <color-input mode="hsl"
                     :target="target" />
      </div>

      <div class="color-input-row"
           v-if="showColorMode('hsluv')">
        <color-input mode="hsluv"
                     :target="target" />
      </div>

      <div class="color-input-row"
           v-if="showColorMode('cmyk')">
        <color-input mode="cmyk"
                     :target="target" />
      </div>

      <div class="color-input-row"
           v-if="showColorMode('css')">
        <color-input mode="rgbCss"
                     :target="target"
                     class="small" />
        <div style="flex: 1"></div>
        <color-input mode="hslCss"
                     :target="target"
                     class="small" />
      </div>

    </div>
  </div>
</template>
<script>
import Color from 'color'
import ColorInput from './ColorInput.vue'
import FlipIcon from './FlipIcon.vue';

export default {
  components: { ColorInput, FlipIcon },
  props: ['target', 'label'],
  mounted() {},
  data() {
    return {};
  },
  computed: {
    activeColor() {
      return this.target === 'foreground'
        ? this.$store.getters.foreground
        : this.$store.getters.background;
    },
    reverseColor() {
      return this.target === 'foreground'
        ? this.$store.getters.background
        : this.$store.getters.foreground;
    },
  },
  methods: {
    hasGlobalFocus() {
      return this.$store.state.picker.selected === this.target;
    },
    setSelected() {
      this.$store.commit('setSelected', this.target);
    },
    showColorMode(mode) {
      return this.$store.getters.showColorMode(mode)
    },
    sampleColor() {
      if (window.webkit) {
        window.pickerTarget = this.target
        window.webkit.messageHandlers.jsHandler.postMessage('startOSPicker');
        // window.webkit.messageHandlers.jsHandler.startOSPicker();
      }

      // electron
      // if (window.startOSPicker) {
      //   window.startOSPicker((value) => {
      //     console.log('app got color', value)
      //     this.$store.commit('setColor', {
      //       target: this.target,
      //       value,
      //       mode: 'hex'
      //     })
      //   })
      // }
    }
  },
  watch: {},
};
</script>

<style lang="scss">
@import './color-selector';


</style>
